export default "__VITE_ASSET__Cfz9fj7p__"